import React from 'react';
import PropTypes from 'prop-types';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import MemberAutocomplete from '../../../../../Feeds/components/AdminLearnerModal/MemberAutocomplete';
import {
  formatEditorLabel,
  isPersonOptionEqual,
  passthroughFilterOptions,
} from '../../../../utils/case-plan-create.util';
import SectionTitle from '../SectionTitle';
import EditorChip from './EditorChip';
import { useEditorsSectionHook } from './useEditorsSectionHook';
import { useEditorsSectionStyles } from './EditorsSection.styles';

/**
 * Optional editors section using shared MemberAutocomplete.
 * Presentational only — logic lives in useEditorsSectionHook.
 */
export const EditorsSection = ({ editors, onEditorsChange }) => {
  const classes = useEditorsSectionStyles();
  const {
    isLoading,
    selectedMembers,
    memberOptions,
    helperText,
    handleSearchChange,
    handleMembersChange,
    handleRemoveEditor,
    getOptionDisabled,
  } = useEditorsSectionHook(editors, onEditorsChange);

  return (
    <Box className={classes.root}>
      <SectionTitle title="Editors" suffix="- optional" />
      <Box className={classes.search}>
        <MemberAutocomplete
          multiple
          label="Plan Editors"
          placeholder="Search staff by name or username"
          memberOptions={memberOptions}
          selectedMembers={selectedMembers}
          onMembersChange={handleMembersChange}
          onSearchChange={handleSearchChange}
          isMemberListLoading={isLoading}
          filterOptions={passthroughFilterOptions}
          getOptionLabel={formatEditorLabel}
          getOptionDisabled={getOptionDisabled}
          isOptionEqualToValue={isPersonOptionEqual}
          rootClassName="editors-autocomplete-root"
        />
        <Box className={classes.supportingText}>
          <InfoOutlinedIcon className={classes.infoIcon} fontSize="inherit" />
          <Typography variant="subtitle1" className={classes.helper}>
            {helperText}
          </Typography>
        </Box>
        <Box className={classes.chips}>
          {editors.map((editor) => (
            <EditorChip
              key={editor.personId}
              editor={editor}
              onRemove={handleRemoveEditor}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

EditorsSection.propTypes = {
  editors: PropTypes.arrayOf(PropTypes.object),
  onEditorsChange: PropTypes.func.isRequired,
};

EditorsSection.defaultProps = {
  editors: [],
};

export default EditorsSection;
